module.exports = __webpack_public_path__ + "static/media/securityplus.112902ea.png";